"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Root = exports.ItemLabel = exports.ArrowIconButton = void 0;
var _mui = require("@ori-ui/mui");
var _RouterLink = require("./RouterLink");
var _jsxRuntime = require("react/jsx-runtime");
const Root = exports.Root = (0, _mui.styled)((props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.ListItem, {
        component: _RouterLink.RouterLink,
        ...props
    }))((param)=>{
    let { theme } = param;
    return {
        border: "2px solid ".concat(theme.palette.grey[100]),
        cursor: 'pointer',
        borderRadius: theme.spacing(4),
        overflowWrap: 'break-word',
        padding: theme.spacing(3),
        width: 'initial',
        display: 'flex',
        alignItems: 'center'
    };
});
const ItemLabel = exports.ItemLabel = (0, _mui.styled)(_mui.ListItemText)((param)=>{
    let { theme } = param;
    return {
        overflow: 'hidden',
        width: '100%',
        margin: 0,
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1),
        ["& .".concat(_mui.listItemTextClasses.primary)]: {
            color: theme.palette.text.primary,
            fontWeight: 'bold'
        },
        ["& .".concat(_mui.listItemTextClasses.secondary)]: {
            color: theme.palette.text.primary
        }
    };
});
const ArrowIconButton = exports.ArrowIconButton = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        color: theme.palette.default.main,
        alignSelf: 'center'
    };
});
